export const GET_EMAILS_LEFT_API = "/marketing/emails-left/";

export const SEND_EMAIL_API = "/marketing/email/";

export const ADD_MARKETING_IMAGE_API = "/settings/image/";


// WEBPACK FOOTER //
// ./src/apis/marketing.js